(() => {
    const US_STORE_HOST = 'us.saboskirt.com';
    const AU_STORE_HOST = 'saboskirt.com';
    const AU_STORE_HOST_ALIASES = ['www.saboskirt.com'];
    const COOKIE_NAME = 'openGeClose';
    const COOKIE_VALUE = '1';
    const COOKIE_TTL_MS = 3 * 60 * 60 * 1000; // 3 hours

    /**
     * @param {string} name
     */
    function getCookie(name) {
        const match = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')}=([^;]*)`));
        return match ? decodeURIComponent(match[1] || '') : null;
    }

    /**
     * @param {string} name
     * @param {string} value
     * @param {number} ttlMs
     */
    function setCookie(name, value, ttlMs) {
        const d = new Date();
        d.setTime(d.getTime() + ttlMs);
        document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${d.toUTCString()}; path=/`;
    }

    function isUsStore() {
        return (window.location.hostname || '').toLowerCase() === US_STORE_HOST;
    }

    function isAuStore() {
        const host = (window.location.hostname || '').toLowerCase();
        if (!host) return false;
        if (host === AU_STORE_HOST) return true;
        if (AU_STORE_HOST_ALIASES.includes(host)) return true;
        return false;
    }

    /**
     * @param {string} targetHost
     * @param {string} utmSource
     * @param {string} utmMedium
     */
    function buildRedirectUrlToHost(targetHost, utmSource, utmMedium) {
        const current = new URL(window.location.href);
        current.protocol = 'https:';
        current.hostname = targetHost;
        current.port = '';
        // Preserve existing querystring, but ensure we can attribute the redirect
        current.searchParams.set('utm_source', utmSource || 'geo_redirect');
        current.searchParams.set('utm_medium', utmMedium || 'redirect');
        return current.toString();
    }

    function tryCadCurrencySwitch() {
        const params = new URL(window.location.href).searchParams;
        const utm = params.get('utm_medium');
        if (utm !== 'CAD') return false;
        if (isUsStore()) return false;

        // This theme uses Shopify's localization form. Setting country_code=CA will switch to CAD (if enabled).
        const form = document.querySelector('form[action*="/localization"]');
        if (!(form instanceof HTMLFormElement)) return false;

        const countryInput = form.querySelector('input[name="country_code"]');
        if (!(countryInput instanceof HTMLInputElement)) return false;

        if (String(countryInput.value || '').toUpperCase() === 'CA') return false;

        countryInput.value = 'CA';
        try {
            form.submit();
            return true;
        } catch {
            return false;
        }
    }

    function ensureStyles() {
        if (document.getElementById('geo-redirect-styles')) return;
        const style = document.createElement('style');
        style.id = 'geo-redirect-styles';
        style.textContent = `
        .geo-redirect-banner {
          border-block-end: 1px solid var(--color-border, rgba(0,0,0,0.1));
        }
        .geo-redirect-banner__inner {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.35em;
          padding: 10px 0;
          font-size: 12px;
          line-height: 1;
          text-align: center;
          white-space: nowrap;
        }
        .geo-redirect-banner__link {
          text-decoration: underline;
          font-weight: 700;
          color: inherit;
        }
        .geo-redirect-overlay {
          position: fixed;
          inset: 0;
          z-index: 2147483647;
          background: rgba(0,0,0,0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 16px;
        }
        .geo-redirect-modal {
          background: #faf9f9;
          color: #332f30;
          width: min(450px, 100%);
          border-radius: 0;
          position: relative;
        }
        .geo-redirect-modal__content {
          padding: 18px 18px 16px;
          text-align: center;
          font-family: sans-serif;
          font-size: 15px;
          font-weight: 300;
          line-height: 1.35;
        }
        .geo-redirect-modal__title {
          display: block;
          margin-bottom: 12px;
          font-size: 18px;
          font-weight: 400;
        }
        .geo-redirect-modal__buttons {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
          padding: 0 18px 18px;
        }
        .geo-redirect-modal__btn {
          border: 0;
          cursor: pointer;
          padding: 10px 12px;
          font-size: 14px;
          background: #332f30;
          color: #fff;
        }
        .geo-redirect-modal__btn:hover { opacity: 0.85; }
        .geo-redirect-modal__close {
          position: absolute;
          top: 6px;
          right: 10px;
          border: 0;
          background: transparent;
          color: #332f30;
          font-size: 22px;
          line-height: 1;
          cursor: pointer;
        }
        @media screen and (max-width: 480px) {
          .geo-redirect-modal__buttons { grid-template-columns: 1fr; }
        }
      `;
        document.head.appendChild(style);
    }

    /**
     * @param {string} redirectUrl
     */
    function insertBanner(redirectUrl) {
        if (document.getElementById('geo-redirect-banner')) return;
        const container = document.getElementById('announcement-bar') || document.querySelector('.announcement-bar');
        if (!container) return;

        const banner = document.createElement('div');
        banner.id = 'geo-redirect-banner';
        banner.className = 'geo-redirect-banner';
        const isOnUs = isUsStore();
        const label = isOnUs ? 'Shop Here' : 'Shop Here';
        const suffix = isOnUs ? 'for AU Orders.' : 'for USA Orders.';
        banner.innerHTML = `
        <div class="page-width">
          <div class="geo-redirect-banner__inner">
            <a class="geo-redirect-banner__link" href="${redirectUrl}">${label}</a>
            <span>${suffix}</span>
          </div>
        </div>
      `;

        container.insertAdjacentElement('afterbegin', banner);
    }

    /**
     * @param {string} countryName
     * @param {string} countryHandle
     * @param {string} redirectUrl
     */
    function showPopup(countryName, countryHandle, redirectUrl) {
        if (document.getElementById('geo-redirect-overlay')) return;
        if (getCookie(COOKIE_NAME) === COOKIE_VALUE) return;

        // Avoid annoying merchants in the theme editor preview.
        if (window.Shopify && window.Shopify.designMode) return;

        const onUsStore = isUsStore();
        const flag = onUsStore ? '🇦🇺' : (String(countryHandle || '').toUpperCase() === 'US' ? '🇺🇸' : '🇨🇦');
        const title = onUsStore ? 'Shopping internationally?' : 'Are you shipping to the';
        const message = onUsStore
            ? `It looks like you’re visiting from <b>${countryName || ''}</b>. For international orders, please use our AU store.`
            : `<b><span>${countryName || ''}</span></b> <span aria-hidden="true">${flag}</span>?`;
        const yesLabel = onUsStore ? `YES, take me to AU ${flag}` : `YES, I am ${flag}`;
        const noLabel = onUsStore ? `NO, stay on US store` : `NO, I'm shipping elsewhere`;

        const overlay = document.createElement('div');
        overlay.id = 'geo-redirect-overlay';
        overlay.className = 'geo-redirect-overlay';
        overlay.innerHTML = `
        <div class="geo-redirect-modal" role="dialog" aria-modal="true" aria-label="Store redirect">
          <button type="button" class="geo-redirect-modal__close" aria-label="Close">×</button>
          <div class="geo-redirect-modal__content">
            <span class="geo-redirect-modal__title">${title}</span>
            <span>${message}</span>
          </div>
          <div class="geo-redirect-modal__buttons">
            <button type="button" class="geo-redirect-modal__btn geo-redirect-yes">${yesLabel}</button>
            <button type="button" class="geo-redirect-modal__btn geo-redirect-no">${noLabel}</button>
          </div>
        </div>
      `;

        function close() {
            overlay.remove();
            setCookie(COOKIE_NAME, COOKIE_VALUE, COOKIE_TTL_MS);
        }

        overlay.querySelector('.geo-redirect-yes')?.addEventListener('click', () => {
            (window.top || window).location.href = redirectUrl;
        });
        overlay.querySelector('.geo-redirect-no')?.addEventListener('click', close);
        overlay.querySelector('.geo-redirect-modal__close')?.addEventListener('click', close);
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) close();
        });

        document.body.appendChild(overlay);
    }

    async function run() {
        const onUsStore = isUsStore();

        // 0) Allow manual redirect via the country/currency selector shortcuts
        // - On AU store: elements flagged as US redirect should send to US store.
        // - On US store: elements flagged as AU redirect should send to AU store.
        if (!onUsStore) {
            document.querySelectorAll('[data-us-store-redirect]').forEach((el) => {
                if (!(el instanceof HTMLElement)) return;
                if (el.dataset.usStoreRedirectBound === '1') return;
                el.dataset.usStoreRedirectBound = '1';
                /** @param {Event} e */
                const handler = (e) => {
                    e.preventDefault?.();
                    e.stopPropagation?.();
                    (window.top || window).location.href = buildRedirectUrlToHost(US_STORE_HOST, 'sabo_us', 'selector');
                };
                el.addEventListener('click', handler);
                el.addEventListener('keydown', (e) => {
                    if (e instanceof KeyboardEvent && (e.key === 'Enter' || e.key === ' ')) handler(e);
                });
            });
        } else {
            document.querySelectorAll('[data-au-store-redirect]').forEach((el) => {
                if (!(el instanceof HTMLElement)) return;
                if (el.dataset.auStoreRedirectBound === '1') return;
                el.dataset.auStoreRedirectBound = '1';
                /** @param {Event} e */
                const handler = (e) => {
                    e.preventDefault?.();
                    e.stopPropagation?.();
                    (window.top || window).location.href = buildRedirectUrlToHost(AU_STORE_HOST, 'sabo_au', 'selector');
                };
                el.addEventListener('click', handler);
                el.addEventListener('keydown', (e) => {
                    if (e instanceof KeyboardEvent && (e.key === 'Enter' || e.key === ' ')) handler(e);
                });
            });
        }

        // 1) CAD param handling (matches prior behavior but using localization form)
        if (tryCadCurrencySwitch()) return;

        // 2) Geo prompt + announcement banner
        let json = null;
        try {
            const r = await fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' });
            if (r.ok) json = await r.json();
        } catch {
            json = null;
        }

        const handle = json?.detected_values?.country?.handle;
        const name = json?.detected_values?.country?.name;

        // On AU store: prompt US/CA visitors to switch to US store.
        // On US store: prompt everyone *except* US/CA to switch to AU store.
        if (!onUsStore) {
            if (handle !== 'US' && handle !== 'CA') return;
        } else {
            if (!handle) return;
            if (handle === 'US' || handle === 'CA') return;
        }

        ensureStyles();
        const url = onUsStore
            ? buildRedirectUrlToHost(AU_STORE_HOST, 'sabo_au', 'redirect')
            : buildRedirectUrlToHost(US_STORE_HOST, 'sabo_us', 'redirect');
        insertBanner(url);
        showPopup(name, handle, url);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
        run();
    }
})();


